import {
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { Card, CardContent } from 'components/cards/Card';
import React, { useState } from 'react';
import { CreateQuestionInput } from '../../';
import { TEMPLATE_DATABASE } from './templateDatabase';
import { OverlayProps } from 'components/TaskOverlay';
import { CardHighlightIcon } from 'components/cards/CardHighlightIcon';

export interface FormTemplate {
  title: string;
  icon: React.ReactElement;
  questions: CreateQuestionInput[];
}

interface FormTemplatesModalProps extends OverlayProps {
  onInstantiateTemplate(template: FormTemplate, onCompleted: () => void): void;
}

export const FormTemplatesModal = ({
  onInstantiateTemplate,
  isOpen,
  onClose,
}: FormTemplatesModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t`Templates`}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack pb={4}>
            {TEMPLATE_DATABASE.map((getTemplate, index) => (
              <TemplateCard
                key={index}
                template={getTemplate()}
                onInstantiateTemplate={onInstantiateTemplate}
                onClose={onClose}
              />
            ))}
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

interface TemplateCardProps {
  onInstantiateTemplate(template: FormTemplate, onCompleted: () => void): void;

  template: FormTemplate;
  onClose: () => void;
}

const TemplateCard = ({
  template,
  onInstantiateTemplate,
  onClose,
}: TemplateCardProps) => {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <Card isNotClickable>
      <Stack direction="row" spacing={0}>
        <CardHighlightIcon>{template.icon}</CardHighlightIcon>
        <CardContent>
          <Stack spacing={4}>
            <Heading size="sm">{template.title}</Heading>
            <HStack justifyContent="flex-end">
              <Text color="gray.500">{t`${template.questions.length} questions`}</Text>
              <Button
                colorScheme="blue"
                size="sm"
                onClick={() => {
                  setIsCreating(true);
                  onInstantiateTemplate(template, () => {
                    setIsCreating(false);
                    onClose();
                  });
                }}
                fontWeight="bold"
                isLoading={isCreating}
                isDisabled={isCreating}
              >{t`Use`}</Button>
            </HStack>
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );
};
